import { render, staticRenderFns } from "./VeHrPeixunReviewList.vue?vue&type=template&id=02de2f9d&scoped=true"
import script from "./VeHrPeixunReviewList.vue?vue&type=script&lang=js"
export * from "./VeHrPeixunReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02de2f9d",
  null
  
)

export default component.exports